module.exports = __webpack_public_path__ + "media/images/mailer_logo-d0cf36a0e4563464a268e26a39cec131.png";